export default {
  text: 'Je hebt {{points}} punten ({{amount}}) verdiend bij deze bestelling',
  button: 'Inloggen en punten claimen',
};
